import { MatchKeyJoin } from "@/components/MatchKey/MatchKeyShell";
import { KARNOFFEL_CFG } from "@/components/MatchKey/cfgs";

export default function KarnoffelJoinPage() {
  return <MatchKeyJoin cfg={KARNOFFEL_CFG} />;
}
